module.exports = __webpack_public_path__ + "assets/4d5df39c341c7abcbdfcf6f4a916c401.mp3";